import React, {useEffect} from 'react';
import $ from "../../utils/datatables";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';
import moment from "moment";
import {GET_ACTIVITY_LOG_URL} from "../../api";

const Activity = (props) => {

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#activity_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Loading activity</p>'
            },
            searching: true,
            lengthMenu: [[10, 25, 50], [10, 25, 50]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                const page = Math.floor(data.start / data.length) + 1;
                $.ajax(GET_ACTIVITY_LOG_URL, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    data: {
                        page: page,
                        page_size: data.length
                    },
                    success: function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load activity', {position: "top-right", autoClose: 5000});
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            columns: [
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" }
            ],
            columnDefs: [
                {
                    render: function(data) {
                        return (data?.event ?? '—').replace(/\./g, ' ');
                    },
                    targets: 0
                },
                {
                    render: function(data) {
                        return (data?.message ?? '—');
                    },
                    targets: 1
                },
                {
                    render: function(data) {
                        return (data?.actor_name ?? '—');
                    },
                    targets: 2
                },
                {
                    render: function(data) {
                        return data?.created_at ? moment(data.created_at).format("Do MMM, YYYY HH:mm") : '—';
                    },
                    targets: 3
                }
            ]
        });
    }, [token]);

    const reloadTable = () => {
        if ($.fn.DataTable.isDataTable('#activity_table')) {
            $('#activity_table').DataTable().ajax.reload(null, false);
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Activity</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Activity Log</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Activity Log</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="activity_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th className="wd-15p">Event</th>
                                            <th className="wd-40p">Message</th>
                                            <th className="wd-15p">Actor</th>
                                            <th className="wd-20p">Date</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Activity;
